import { getZonedDate } from '@eika-infrastruktur/date';

import type { EFaktura, EFakturaId } from '../../../../generated-types';
import { FormattedFuturePayment } from '../../../../utils/mapper/futurepaymentsUtil';
import { CommonPaymentState } from '../../form/CommonPaymentState';

export interface EfakturaState extends CommonPaymentState {
    efakturaId?: EFakturaId;
    minimumAmount?: number;
    totalAmount: number;
    hasInitialKid?: boolean;
    note: string;
    acceptDuplicate: boolean;
}

export const efakturaInitialState: EfakturaState = {
    efakturaId: undefined,
    kid: undefined,
    hasInitialKid: false,
    fromAccount: undefined,
    amount: undefined,
    note: '',
    totalAmount: 0,
    showFromAccounts: false,
    futurePaymentAmount: undefined,
    acceptDuplicate: false,
};

export const getInitialState = (eFaktura: EFaktura): EfakturaState => ({
    ...efakturaInitialState,
    efakturaId: eFaktura.id,
    paymentDate: getZonedDate(eFaktura.paymentDate),
    totalAmount: eFaktura.amount,
    amount: eFaktura.amount,
    kid: eFaktura.kid,
    hasInitialKid: !!eFaktura.kid,
    minimumAmount: eFaktura.minimumAmount,
    fromAccount: eFaktura.fromAccount,
    toAccount: eFaktura.toAccountNumber
        ? { accountNumber: eFaktura.toAccountNumber, accountName: eFaktura.issuerName }
        : undefined,
});

export const getFutureState = (futurePayment: FormattedFuturePayment): EfakturaState => ({
    ...efakturaInitialState,
    paymentDate: getZonedDate(futurePayment.date),
    note: futurePayment.description || '',
    amount: Math.abs(futurePayment.amount),
    totalAmount: Math.abs(futurePayment.amount),
    futurePaymentAmount: Math.abs(futurePayment.amount),
    fromAccount: futurePayment.fromAccount.accountNumber,
    toAccount: futurePayment.toAccount.accountNumber
        ? { accountNumber: futurePayment.toAccount.accountNumber, accountName: futurePayment.toAccount.name }
        : undefined,
});
